<template>
  <hr class="hr-full-width">
</template>

<style lang="scss" scoped>
  .hr-full-width {
    // This makes the element full-width, assuming that it's in currently padded by 30px on left and right,
    // as campaign action sidebar content is.
    margin-left: -30px;
    margin-right: -30px;
  }
</style>
